<style>
	.menu {
		cursor: pointer;
	}
</style>
<template>
	<div>
	<v-text-field :label="label" :placeholder="placeholder" v-model="object[objectKey]" append-icon="mdi-code-parentheses" v-on:click.right="showMenu"></v-text-field>	
	<v-menu class="menu" v-model="showRightClickMenu" :position-x="x" :position-y="y">
		<v-list dense>
		<v-list-item-group v-for="element in elements" :key="element.name">
			<v-list-item>
				<v-list-item-title @click="insertQuestionString(element)">{{element.title}}</v-list-item-title>
			</v-list-item>
			<v-list class="ml-5" dense v-if="element.rows">
				<v-list-item v-for="row in element.rows" :key="row.value">
					<v-list-item-title class="menu" @click="insertQuestionString(element, row)">{{row.text}}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-list-item-group>
		</v-list>
	</v-menu>	

	<v-dialog v-model="showSubquestionDialog" max-width="290" >
		<v-card>
			<v-card-title class="headline">Insert merge field</v-card-title>
			<v-card-text>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" text @click="showSubquestionDialog = false" >Done</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	</div>
</template>

<script type="text/javascript">
	
	export default {
		name: "TextInputWithMergeField", 
		props: {
			label: {type: String},
			placeholder: {type: String},
			object: {type: Object},
			objectKey: {type: String},
			elements: {type: Array}
		},
		data: () => {
			return{
				showSubquestionDialog: 0,
				cursorPosition: 0, 
				showRightClickMenu: 0,
				x: 0,
				y: 0 
			}
		},
		methods:{
			showMenu(event){
				if( this.elements.length == 0 ){
					return false;
				}
				event.preventDefault();
				this.cursorPosition = event.target.selectionStart;
				this.x = event.x;
				this.y = event.y;
				this.showRightClickMenu = 1;
			},
			insertQuestionString(question, subquestion){
				if( question.rows && !subquestion ){ return false; }
				let id = "";
				if( !question.rows ){
					id = "{" + question.name + "}"
				}
				else if( subquestion ){
					id = "{" + question.name + "." + subquestion.value + "}"
				}
				let before = this.object[this.objectKey].substr( 0, this.cursorPosition )
				let after = this.object[this.objectKey].substr( this.cursorPosition  )
				this.object[this.objectKey] = before + id + after;
			}
		}
	}
</script>